import { render, staticRenderFns } from "./Ghost.vue?vue&type=template&id=c3348334&scoped=true&"
import script from "./Ghost.vue?vue&type=script&lang=js&"
export * from "./Ghost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3348334",
  null
  
)

export default component.exports